









































































import { MultiResourceMixin } from '@/mixins/multiResourceMixin'
import { AccountPicker2ElInterface, Resource } from '@/config/interfaces'

export default MultiResourceMixin.extend({
  name: 'AccountPicker2El',
  props: {
    templateItemData: {
      type: Object as () => AccountPicker2ElInterface,
      required: true
    }
  },
  computed: {
    inactiveResources (): Array<Resource> {
      return this.$store.getters.getMsisdns
    },
    bundleResources (): Array<Array<Resource>> {
      const msisdnBundles = this.$store.getters.getMsisdnsBundles
      return msisdnBundles.filter((msisdnBundle: Array<Resource>) => {
        return (msisdnBundle.length === 1 && !msisdnBundle[0].active) || (msisdnBundle.length > 1)
      })
    },
    activeIdentifier (): Resource {
      return this.$store.getters.getMsisdn
    },
    hasResources (): boolean {
      return this.$store.getters.getMsisdns.length > 0
    },
    hasMultiResource (): boolean {
      return this.$store.getters.getMsisdns.length > 1
    },
    resolveLeftBorderPosition (): boolean {
      return this.$store.getters.getMsisdns.length === 1 && this.isDesktop
    }
  },

  methods: {
    getBundleSeparatorColor (resourceBundle: Array<Resource>): string {
      if (resourceBundle.some(identifier => {
        return identifier.primary
      })) {
        return this.templateItemData.primaryColorSeparator
      }
      return this.templateItemData.colorSeparator
    },
    getResourceSeparatorColor (): string {
      if (this.activeIdentifier.primary) {
        return this.templateItemData.primaryColorSeparator
      }
      return this.templateItemData.colorSeparator
    }
  },
  mounted () {
    if (!this.hasResources) {
      const allIdentifiers: Array<Resource> = []
      this.$props.templateItemData.list.forEach((identifiers: Array<Resource>) => {
        identifiers.forEach((identifier: Resource) => {
          allIdentifiers.push(identifier)
        })
      })
      this.$store.dispatch('commitIdentifiers', allIdentifiers)
      this.$store.dispatch('commitIdentifiersBundles', this.$props.templateItemData.list)
    }
  }
})
